module.exports = {
    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler :
        [
            "res/sounds/down_deck",
            "res/sounds/slide_deck",
            "res/sounds/btn_click",
            "res/sounds/deck_click",
            "res/sounds/fly_card",
            "res/sounds/forward",
            "res/sounds/lose",
            "res/sounds/win",
            "res/sounds/rotate0",
            "res/sounds/rotate1",
            "res/sounds/rotate2",
        ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi :
        [
            //
        ]
};


//////////////////
// WEBPACK FOOTER
// ./res/resources.js
// module id = 114
// module chunks = 0